import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteConditionMutationProps = {
	id: string | null
	onSettled: () => void
}

export const useDeleteConditionMutation = ({ id, onSettled }: UseDeleteConditionMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: deleteConditionMutation } = useMutation({
		mutationFn: () => axiosPrivate.delete(apiRoutes.condition(id!)),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Condition deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.conditions.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteConditionMutation
	}
}
